import { useEffect } from 'react'

import { TypographyGroupValue, TypographySelectValue } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { CustomFontsRecord } from '@/shared/builder/types'

function collectCustomFonts(fontsRecord: CustomFontsRecord, settings: Record<string, any>) {
  for (const [key, value] of Object.entries(settings)) {
    // find all keys that end with -typography
    if (key.endsWith('-typography')) {
      // get setting value
      const currSettings = value as TypographyGroupValue | TypographySelectValue

      // Skip if currSettings is undefined or null
      if (!currSettings) {
        continue
      }

      // if its a group, collect recursively
      if (!('typography' in currSettings)) {
        collectCustomFonts(fontsRecord, currSettings)
        continue
      }

      const typoSettings = currSettings as TypographySelectValue
      if (!typoSettings.custom) continue

      // get custom font family
      const { fontFamily, fontStyle } = typoSettings.custom

      if (!fontsRecord[fontFamily]) {
        fontsRecord[fontFamily] = { fontStyle }
      } else {
        fontsRecord[fontFamily][fontStyle] = fontStyle
      }
    }
  }

  return fontsRecord
}

/**
 * This hook is used to load custom fonts from the component settings.
 * it will inject the custom fonts into the global app builder context.
 */
export function useLoadCompCustomFonts(compSettings: Record<string, any>) {
  // access app builder context
  const { setCustomFonts } = useAppBuilderContext()

  // collect custom fonts to load from component settings
  useEffect(() => {
    setCustomFonts((prev) => collectCustomFonts(prev, compSettings))
  }, [compSettings, setCustomFonts])
}
